import axios from "axios";
import {  toast } from 'react-toastify';

const requestInstance = axios.create();

// Multi-tenancy: on a common URL the tenant chosen at identify-first login is
// remembered in localStorage("tenantId"); send it as x-tenant so the backend
// scopes lookups (incl. the pre-auth login/OTP calls). No-op when nothing was
// remembered (subdomain deployments) or when a caller already set x-tenant.
//
// 2026-08-23: when a JWT is present, PREFER ITS tenantId CLAIM over the
// stored value. The backend rejects claim≠header with 401 (security: a token
// must not be replayed under another tenant), and the response interceptor
// treats 401 as session-death — so a STALE localStorage tenantId (left over
// from a previous login as a different identity) turned every call into an
// instant logout loop. The claim is authoritative; localStorage is only the
// pre-auth memory for identify/login/OTP.
const tenantIdFromToken = () => {
  try {
    const token = localStorage.getItem('token');
    if (!token) return null;
    const payload = token.split('.')[1];
    if (!payload) return null;
    const decoded = JSON.parse(atob(payload.replace(/-/g, '+').replace(/_/g, '/')));
    return decoded?.tenantId || null;
  } catch (e) {
    return null;
  }
};

export const applyTenantHeader = (config) => {
  try {
    const claim = tenantIdFromToken();
    const tenantId = claim || localStorage.getItem('tenantId');
    if (!tenantId || !config) return config;
    if (!config.headers) config.headers = {};
    const hasTenant =
      typeof config.headers.has === 'function'
        ? config.headers.has('x-tenant')
        : Boolean(config.headers['x-tenant']);
    if (!hasTenant) config.headers['x-tenant'] = tenantId;
    // keep the remembered id in sync with the active session
    if (claim && localStorage.getItem('tenantId') !== claim)
      localStorage.setItem('tenantId', claim);
  } catch (e) {
    // never block a request over the tenant header
  }
  return config;
};

let token = localStorage.getItem("token") || "";
requestInstance.interceptors.request.use(
    (config) => {
      const connection = navigator.onLine;
      token = localStorage.getItem("token") || "";
      if (connection === false) {
        toast.error("No Internet Connection");
        return false;
      }
      if (token && (token !== 'undefined' || token !== undefined)) {
        if(config.method === 'patch' || config.method === 'post'){
          config.headers = {
            "Content-Type": 'application/x-www-form-urlencoded',
            Authorization: `Bearer ${token}`,
          };
        }else{
          config.headers = {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          };
        }
      } else {
        config.headers = {
          "Content-Type": "application/json",
        };
      }

      return applyTenantHeader(config);
    },
    (error) => {
      toast.error(error);
      return Promise.reject(error);
    }
  );
  
  // Add a response interceptor
  requestInstance.interceptors.response.use(
    function (response) {
      return response;
    },
    function (error) {
      // const navigate = useNavigate();
  
      // if (error?.response?.data) {
      //   toast.error(error?.response?.data?.message);
      // }
      if (error?.response?.status === 403 || error?.response?.status === 401) {
        localStorage.clear();
        window.location.pathname = "/login";
      }
      return Promise.reject(error);
    }
  );
  
  export default requestInstance;